export class ColorDataType{
	public static readonly galvanizado : number = 0;
	public static readonly verde : number = 1;
	public static readonly zinc : number = 2;
	public static readonly vino : number = 3;
	public static readonly rojo : number = 4;
	public static readonly oxiron : number = 5;
	public static readonly metalico : number = 6;
	public static readonly piedra : number = 7;
	public static readonly negro : number = 8;
	public static readonly azul : number = 9;
	public static readonly blanco : number = 10;
	public static readonly antracita : number = 11;
}